<template>
  <smd-one-col-layout class="modal-privacy-policy">
    <smd-header slot="header" nav>
      <span class="ns-icon-ico027"
            slot="left-actions"
            @click="closeModal"/>

      <p class="Title3 gray-400">Privacy Policy</p>

      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <text-string label-id="txt1478" class="m-b-20"/>

    <div class="smd-checkbox__row">
      <smd-checkbox v-model="privacyAgreed">
        <p class="Body3">I agree to the privacy policy above</p>
      </smd-checkbox>
    </div>

  </smd-one-col-layout>
</template>

<script>
  import {mapFields} from 'vuex-map-fields';
  import CloseModalMixin from '@/mixins/close-modal-mixin';

  export default {
    name: 'modal-privacy-policy-freestyle',
    mixins: [CloseModalMixin],
    computed: {
      ...mapFields('program', {
        privacyAgreed: 'privacyAgreed',
      }),
    },
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .modal-terms-and-conditions {
    .smd-checkbox__row {
      margin-bottom: space(m);

      .smd-checkbox {
        align-items: flex-start;
      }
    }
  }
</style>
